import React from 'react';
import { CountdownBanner } from '../components/CountdownBanner';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="w-full min-h-screen bg-navy-dark" data-id="element-163">
      <CountdownBanner data-id="element-164" />
      <HeroSection data-id="element-165" />
      <ProblemSection data-id="element-166" />
      <SolutionSection data-id="element-167" />
      <OfferSection data-id="element-168" />
      <Footer data-id="element-169" />
    </main>;
}